import { Chart as ChartJS } from 'chart.js';
import { jsPDF } from 'jspdf';
import { useCallback, useMemo } from 'react';
import { FilterSelectedValue } from '../../../hooks/filters/interfaces/filter-selected-value.interface';
import { Filter } from '../../../hooks/filters/interfaces/filter.interface';
import { FILTER_NAMES } from '../../filters/hooks/filter-names.constants';
import { useFilterContext } from '../../filters/provider/filter.provider';
import { ExportButtonDownloader } from '../components/export-button/export-button.component';

export const usePDFDownloader = (
  filterSelection: FilterSelectedValue[],
  filename: string,
  title: string,
  chart?: ChartJS<'line', unknown, unknown> | null,
): ExportButtonDownloader => {
  const filters = useFilterContext();

  const download = useCallback(() => {
    const marginTop = 40;
    const lineSpace = 10;
    const marginLeft = 10;
    const marginRight = 10;
    let yPos = marginTop;
    if (chart?.canvas) {
      const canvasImage = chart.canvas.toDataURL('image/png', 1.0);
      const doc = new jsPDF({
        unit: 'px',
        format: 'a4',
      });
      doc.text(title, marginLeft, yPos);
      const w = 450 - marginLeft - marginRight;
      const ratio = w / chart.width;
      const h = chart.height * ratio;
      yPos += lineSpace;
      doc.addImage(canvasImage, 'jpeg', marginLeft, yPos, w, h);

      yPos += h;
      const dict: Record<string, Filter> = {};
      const marketTitle =
        filterSelection.find((i) => i.id === FILTER_NAMES.MARKET)?.values[0]
          .label ?? '';
      const metaCatTitle =
        filterSelection.find((i) => i.id === FILTER_NAMES.METACATEGORY)
          ?.values[0].label ?? '';
      yPos += 2 * lineSpace;
      doc.setFontSize(14);

      doc.text('Filters:', marginLeft, yPos);
      filterSelection.forEach((i) => {
        if (i.values.length > 0) {
          const filter = dict[i.id] ?? filters?.find((f) => f.id === i.id);
          const filterName = filter ? filter.name : i.id;

          yPos += 2 * lineSpace;
          doc.setFontSize(10);
          doc.text(`${filterName}:`, marginLeft, yPos);
          i.values.forEach((j) => {
            if (filter) dict[i.id] = filter;

            yPos += lineSpace;
            doc.setFontSize(8);
            const exclude = j.exclude ? ' (Exclude)' : '';
            doc.text(`${j.label}${exclude}`, marginLeft + 20, yPos);
          });
        }
      });

      doc.save(`${filename}-${metaCatTitle}-${marketTitle}.pdf`);
    }
  }, [filename, title, filterSelection, filters, chart]);
  const ret = useMemo(() => ({ download }), [download]);
  return ret;
};
